import { render, staticRenderFns } from "./tickRequestDetails.vue?vue&type=template&id=5ea6fc1f&scoped=true"
import script from "./tickRequestDetails.vue?vue&type=script&lang=js"
export * from "./tickRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./tickRequestDetails.vue?vue&type=style&index=0&id=5ea6fc1f&prod&lang=css"
import style1 from "./tickRequestDetails.vue?vue&type=style&index=1&id=5ea6fc1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea6fc1f",
  null
  
)

export default component.exports